type Stat = { value: number; signed: boolean };

// Цвет числа характеристики: плюс — зелёный, минус — красный, без знака — обычный.
export const statTone = ({ value, signed }: Stat): "plus" | "minus" | "plain" =>
  value < 0 ? "minus" : signed ? "plus" : "plain";
